import { CentreBase, ConsortiumCentres, ModeratorInfo } from '@cambridgeassessment/lib-ee-commons';

export const SET_CENTRE = '@POST_RESULTS/SET_CENTRE';
export const SET_CONSORTIUM = '@POST_RESULTS/SET_CONSORTIUM';
export const SET_MODERATORS = '@POST_RESULTS/SET_MODERATORS';
export const SET_ALLOCATED_MODERATOR = '@POST_RESULTS/SET_APPOINTED_MODERATOR';
export const RESET_CENTRE_STATE = '@POST_RESULTS/RESET_CENTRE_STATE';
export const RESET_CONSORTIUM_STATE = '@POST_RESULTS/RESET_CONSORTIUM_STATE';
export const RESET_MODERATORS_STATE = '@POST_RESULTS/RESET_MODERATORS_STATE';
export const RESET_ALLOCATED_MODERATOR_STATE = '@POST_RESULTS/RESET_ALLOCATED_MODERATOR_STATE';
export const SET_FETCHING_CENTRE = '@POST_RESULTS/SET_FETCHING_CENTRE';

export interface SetCentre {
  type: typeof SET_CENTRE;
  payload: CentreBase[] | undefined;
}

export interface SetConsortium {
  type: typeof SET_CONSORTIUM;
  payload: ConsortiumCentres;
}

export interface SetAllocatedModerator {
  type: typeof SET_ALLOCATED_MODERATOR;
  payload: ModeratorInfo | undefined;
}

export interface SetModerators {
  type: typeof SET_MODERATORS;
  payload: ModeratorInfo[];
}

export interface ResetCentreState {
  type: typeof RESET_CENTRE_STATE;
}

export interface ResetConsortiumState {
  type: typeof RESET_CONSORTIUM_STATE;
}

export interface ResetModeratorsState {
  type: typeof RESET_MODERATORS_STATE;
}

export interface ResetAllocatedModeratorState {
  type: typeof RESET_ALLOCATED_MODERATOR_STATE;
}

export interface SetFetchingCentre {
  type: typeof SET_FETCHING_CENTRE;
  payload: boolean;
}

export type PostResultsActionTypes =
  | SetCentre
  | SetConsortium
  | SetModerators
  | SetAllocatedModerator
  | ResetCentreState
  | ResetConsortiumState
  | ResetModeratorsState
  | ResetAllocatedModeratorState
  | SetFetchingCentre;
